module.exports = __webpack_public_path__ + "img/style_9_pl.4a7443e2.jpeg";